import React, {Component} from 'react';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import MomentUtils from '@date-io/moment';
import {MuiPickersUtilsProvider} from 'material-ui-pickers';
import {Redirect, Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import { IntlProvider, injectIntl } from "react-intl";
import "assets/vendors/style"
import defaultTheme from './themes/defaultTheme';
import AppLocale from '../lngProvider';

import MainApp from 'app/index';
import SignIn from './SignIn';
import Resetpassword from './Resetpassword';
import InaktivaUser from './InaktivaUser';
import NyttPassword from './NyttPassword';
import Validation from './Validation';
import DashboardTV from '../app/routes/DashboardTV';
import DashboardLoopTV from '../app/routes/DashboardLoopTV';
import MailUnsubView from '../app/routes/MailUnsubView';

// import DocumentPreviewSend from '../app/routes/DocumentPreviewSend';

import {getMyUser, setInitUrl,getClientIp1,switchLanguage} from '../actions';
import RTL from 'util/RTL';
import axios from 'util/Api';
import asyncComponent from 'util/asyncComponent';
import {isEmpty,isUndefined} from 'lodash'
import { setIntl } from "../util/intlHelper"; 

const RestrictedRoute = ({component: Component, token, ...rest}) =>
  <Route
    {...rest}
    render={props =>
      token
        ? <Component {...props} />
        : <Redirect
          to={{
            pathname: '/signin',
            state: {from: props.location}
          }}
        />}
  />;
  const IntlWrapper = injectIntl(({ intl, children }) => {
    setIntl(intl); // Store intl instance globally
    return children;
  });


class App extends Component {

  componentWillMount() {
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    this.props.getClientIp1()
    console.log(this.props.history.location)
    if (this.props.initURL === '') {
      if(isEmpty(this.props.history.location.search)){
        this.props.setInitUrl(this.props.history.location.pathname);
      }else{
        this.props.setInitUrl(this.props.history.location);      
      }
      
      //
    }
  }

  getmylocale =(lang)=>{
    switch(lang){
      case "SE": return {
        languageId: 'Swedish',
        locale: 'sv',
        name: 'Svenska',
        icon: 'se'
      }
      case "NO": return  {
        languageId: 'Norwegian',
        locale: 'no',
        name: 'Norska',
        icon: 'no'
      }
      case "US": return  {
        languageId: 'English',
        locale: 'en',
        name: 'engelska',
        icon: 'us'
      }
      default: return {
        languageId: 'Swedish',
        locale: 'sv',
        name: 'Svenska',
        icon: 'se'
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${nextProps.token}`;
    }
    if (nextProps.token && !nextProps.authUser) {
      this.props.getMyUser()
    }
  }
  render() {
    const {match, location, locale,  initURL, isDirectionRTL} = this.props;
    const token = this.props.token
    if (location.pathname === '/') {
      if (token === null) {
          return ( <Redirect to={'/signin'}/> );
      } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
        if(parseInt(this.props.authUser.user_role) === 5){
          return ( <Redirect to={'/app/Order'}/> );
        }else{
          return ( <Redirect to={'/app/Lobby'}/> );
        }
        
      } else {
        return ( <Redirect to={initURL}/> );
      }
    }
    const applyTheme = createMuiTheme(defaultTheme);
    const applyThemeV5 = createTheme(defaultTheme);
    //console.log(token)
    if (isDirectionRTL) {
      applyTheme.direction = 'rtl';
      document.body.classList.add('rtl')
    } else {
      document.body.classList.remove('rtl');
      applyTheme.direction = 'ltr';
    }
    let locale2 = locale
    try{
      locale2=this.getmylocale(this.props.authUser.user_Lang)
    }catch(error){
      console.log(error)
    }
    if(locale2.locale !== locale.locale){
      this.props.switchLanguage(locale2)
    }
    const currentAppLocale = AppLocale[locale2.locale];
    return (
      <ThemeProvider  theme={applyThemeV5}>
        <MuiThemeProvider theme={applyTheme}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <IntlProvider
              locale={currentAppLocale.locale}
              messages={currentAppLocale.messages}>
                <IntlWrapper>
              <RTL>
                <div className="app-main">
                  <Switch>
                    <RestrictedRoute path={`${match.url}app`} token={token}
                                    component={MainApp}/>
                    <Route path='/signin' component={SignIn}/>
                    <Route path='/login' component={SignIn}/>
                    <Route path='/Validation/:Token' component={Validation}/>
                    <Route path='/Resetpassword' component={Resetpassword}/>
                    <Route path='/inactive' component={InaktivaUser}/>
                    <Route path='/NyttPassword/:Token' component={NyttPassword}/>
                    <Route exact path='/DocumentPreview/:Token' component={asyncComponent(() => import('../app/routes/DocumentPreviewSend'))}/>
                    <Route exact path='/Tavla/:Token' component={asyncComponent(() => import('../app/routes/ProjectBoardExtern'))}/>
                    <Route exact path='/TV' component={asyncComponent(() => import('../app/routes/DasboardTVV2'))}/>
                    <Route exact path='/Dashboard/:Token' component={DashboardTV}/>
                    <Route exact path='/DashboardLoop/:Token' component={DashboardLoopTV}/>                  
                    <Route exact path='/unsub/:Contact_Hash' component={MailUnsubView}/>                  
                    <Route
                      component={asyncComponent(() => import('components/Error404'))}/>
                  </Switch>
                </div>
              </RTL>
              </IntlWrapper>
            </IntlProvider>
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
       </ThemeProvider>
    );
  }
}

const mapStateToProps = ({settings, auth}) => {
  const {sideNavColor, locale, isDirectionRTL} = settings;
  const {authUser, token, initURL} = auth;
  return {sideNavColor, token, locale, isDirectionRTL, authUser, initURL}
};

export default connect(mapStateToProps, {setInitUrl, getMyUser,getClientIp1,switchLanguage})(App);

